import { render } from "./LoadingScreen.vue?vue&type=template&id=27084210"
const script = {}

import "./LoadingScreen.vue?vue&type=style&index=0&id=27084210&lang=scss"

import exportComponent from "/home/francesco/opt/quired/abit/resources/js/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__